import { useMemo } from "react";
import { useUserCollections } from "queries";

interface IUseUserCollectionsDataProps {
  userName: string;
}

export const useUserCollectionsData = (
  { userName }: IUseUserCollectionsDataProps
) => {
  const {
    data,
    isError,
    isLoading,
    hasNextPage,
    fetchNextPage
  } = useUserCollections({
    userName
  });

  const items = useMemo(() => {
    if (!data) {
      return [];
    }

    const fetchedItems = data.pages.map((page) => page.collections).flat();
    return fetchedItems;
  }, [data]);

  return {
    items,
    isError,
    isLoading,
    hasNextPage,
    fetchNextPage
  };
};
